<template>
    <div class="relative w-full h-[400px] overflow-hidden">
        <TsImage :src="`${image}?format=webp`" alt="Garden watering scene" class="w-full h-full object-cover" :width="1063" :height="717" />

        <div class="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>

        <div class="absolute inset-0 flex flex-col justify-end p-6 md:p-8">
            <div class="w-full mx-auto md:max-w-screen-xl md:px-4">
                <div class="flex gap-3 mb-3">
                    <span class="px-3 py-1 rounded-full bg-black/30 backdrop-blur-sm text-white text-sm">
                        {{ formatDate(publishDate) }}
                    </span>
                    <span class="px-3 py-1 rounded-full bg-black/30 backdrop-blur-sm text-white text-sm">
                        {{ readTime }} {{ useTranslation('minutes', 'notulen') }}
                    </span>
                </div>

                <div class="flex items-end justify-between">
                    <TsTypography append-class="text-white" as="h1" p="h1" :text="title" />

                    <div class="flex gap-2">
                        <button
                            class="p-2 rounded-full bg-black/30 backdrop-blur-sm hover:bg-black/40 transition-colors border-white border"
                            aria-label="Share" @click="handleShareClick()">
                            <TsIcon class="rounded-full shadow-md p-1 text-white shrink-0 cursor-pointer"
                                name="mdi:share-variant-outline" size="30" @click="emit('share')" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { formatDate } from "~/utils/formatDateAndTime";

type Props = {
    title: string;
    publishDate: string;
    readTime: string;
    image: string;
};
const handleShareClick = ()=>{
    trackShare("Banner","image","title")
}
defineProps<Props>();
const emit = defineEmits(["share"]);
</script>